import * as React from 'react';
import classNames from 'classnames';

var RadioIcon = function (_a) {
    var selected = _a.selected, disabled = _a.disabled;
    return (React.createElement("span", { className: classNames('nv-radio-icon', {
            'nv-radio-icon--disabled': disabled,
            'nv-radio-icon--selected': selected,
        }) }));
};

export { RadioIcon as default };
//# sourceMappingURL=RadioIcon.esm.js.map
